module.exports = __webpack_public_path__ + "static/media/schedule_structure_remove_a_lunch.00f99f4c.mov";